import { css } from 'aphrodite';
import * as React from 'react';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '../../../../../web/components/HoverCard';
import { Modal } from '../../../../../web/components/Modal';
import { Button } from '../../../../../web/components-v2/Button';
import { InfoIcon } from '../../../../../web/components/svgs/icons/InfoIcon';
import { Toggle } from '../../../../../web/components/Toggle';
import { styleSheet } from './styles';

interface ITagSettingsToggleRow {
	id: string;
	label: string;
	hoverText: React.ReactNode;
	isOn: boolean;
	onChange: (value: boolean) => void;
}

interface IProps {
	isOpen: boolean;
	title: string;
	master: {
		id: string;
		label: string;
		isOn: boolean;
		onChange: (value: boolean) => void;
		disabledWarning: string;
	};
	rows: ITagSettingsToggleRow[];
	infoText: string;
	onSave: () => void;
	onCancel: () => void;
}

export const TagSettingsModal: React.FC<IProps> = ({ isOpen, title, master, rows, infoText, onSave, onCancel }) => {
	return (
		<Modal isOpen={isOpen} onRequestClose={onCancel} useDefaultHeader>
			<div className={css(styleSheet.tagSettingsModal)}>
				<div className={css(styleSheet.tagSettingsModalTitle)}>{title}</div>
				<div className={css(styleSheet.tagSettingsModalRow)}>
					<span>{master.label}</span>
					<Toggle id={master.id} isOn={master.isOn} onToggleCheckChanged={master.onChange} uncheckedColor='#ccc' />
				</div>
				{!master.isOn && <p className={css(styleSheet.tagSettingsWarning)}>{master.disabledWarning}</p>}
				{rows.map(row => (
					<div className={css(styleSheet.tagSettingsModalRow)} key={row.id}>
						<span className={css(styleSheet.tagSettingsModalLabel)}>
							{row.label}
							<HoverCard>
								<HoverCardTrigger className={css(styleSheet.tagSettingsModalInfoIcon)}>
									<InfoIcon />
								</HoverCardTrigger>
								<HoverCardContent styles={[styleSheet.tagSettingsModalHoverContent]}>{row.hoverText}</HoverCardContent>
							</HoverCard>
						</span>
						<Toggle
							id={row.id}
							disabled={!master.isOn}
							isOn={row.isOn}
							onToggleCheckChanged={row.onChange}
							uncheckedColor='#ccc'
						/>
					</div>
				))}
				<p className={css(styleSheet.tagSettingsInfo)}>{infoText}</p>
				<div className={css(styleSheet.tagSettingsModalFooter)}>
					<Button variant='primary' onClick={onSave}>
						Save
					</Button>
					<Button variant='secondary' onClick={onCancel}>
						Cancel
					</Button>
				</div>
			</div>
		</Modal>
	);
};
